import React from "react";
import PropTypes from "prop-types";
import SectionItem from "./SectionItem.jsx";
import AudioFile from "./AudioFile.jsx";
import SummaryItem from "./SummaryItem.jsx";

export default class Menu extends React.Component {
  renderMenuEntries = (moduleList) => {
    const menuEntries = moduleList.map((module, index) => {
      return (
        <SummaryItem key={index} itemKey={`${module.dtmfKey}. ${module.name}`}>
          {this.props.renderContent(module.moduleGroup, this.props.sites, true)}
        </SummaryItem>
      );
    });

    return menuEntries;
  };

  render = () => {
    const { ivrModule } = this.props;
    return (
      <span>
        <SectionItem itemKey="Menu Audio">
          <AudioFile audioId={ivrModule.menuAudio} />
        </SectionItem>
        <SectionItem itemKey="">
          <span style={{ fontSize: "0.8em" }}>
            {this.renderMenuEntries(ivrModule.ivrMenuOptionList)}
          </span>
        </SectionItem>
      </span>
    );
  };
}

Menu.propTypes = {
  ivrModule: PropTypes.object,
  renderContent: PropTypes.func,
  sites: PropTypes.array,
};
